import { bestpark } from './base-api';

interface ReserveSlotData {
  startDate: string;
  endDate: string;
  parkId?: number;
  customerId: number;
  slot: number;
}

interface ReserveParkingSlotData {
  startDate: string;
  endDate: string;
  parkId?: number;
  customerId: number;
  parkingSlot: number;
}

interface PostReserveSlotsArgs {
  data: ReserveSlotData;
}

interface PostReserveParkingSlotsArgs {
  data: ReserveParkingSlotData;
}

const postReserveSlots = async ({
  data,
}: PostReserveSlotsArgs): Promise<Reservation> => {
  const result = await bestpark.post('/reserve-slots', data);
  return result.data;
};

const postReserveParkingSlots = async ({
  data,
}: PostReserveParkingSlotsArgs): Promise<Reservation> => {
  const result = await bestpark.post('/reserve-slots/parking', data);
  return result.data;
};

export const reserveSlotsApi = {
  postReserveSlots,
  postReserveParkingSlots,
};
